<template>
    <div class="context">
        <keep-alive include="tableView">
            <component
                :is="componentId"
                @changeTopTab="switchModule"
                :ref="componentId">
            </component>
        </keep-alive>
    </div>
</template>

<script>
    import {mapState} from "vuex"
    import tableView from "./tableView"
    import editView from "./editView"

    export default {
        name: "",
        components: {
            tableView,
            editView,
        },
        data() {
            return {
                componentId: 'tableView'
            }
        },
        methods: {
            switchModule(id) {
                this.componentId = id;
            }
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>